// The Ministry's units as the waitlist offers them (1 Nov 2026, after the Ministry described the Policies and Economic Studies Sector): each
// sector with the sector itself first, for colleagues who work in it rather than in one of its departments, and its departments under it; then
// the units outside any sector, together. Only units that accept files are offered.
import type { Dept } from "./api";

export type Unit = Dept & { kind: string; parentKey: string | null; canContribute: boolean };

export interface SectorGroup { kind: "sector"; key: string; sector: Unit; self: Unit | null; departments: Unit[] }
export interface UnitsGroup { kind: "units"; key: string; units: Unit[] }
export type UnitGroup = SectorGroup | UnitsGroup;

export function unitGroups(all: readonly Unit[], first?: string | null): UnitGroup[] {
  const parents = new Set(all.map((d) => d.parentKey).filter((k): k is string => !!k));
  const top = all.filter((d) => !d.parentKey || !all.some((p) => p.key === d.parentKey));
  const sectors: UnitGroup[] = top.filter((d) => parents.has(d.key))
    .map((s) => ({ kind: "sector" as const, key: s.key, sector: s, self: s.canContribute ? s : null, departments: all.filter((d) => d.parentKey === s.key && d.canContribute) }))
    .filter((g) => g.self || g.departments.length);
  const units = top.filter((d) => d.canContribute && !parents.has(d.key));
  const groups = [...sectors, ...(units.length ? [{ kind: "units" as const, key: "units", units }] : [])];
  if (!first) return groups;
  // The group holding the directory's unit first.
  const holds = (g: UnitGroup) => (g.kind === "sector" ? g.self?.key === first || g.departments.some((d) => d.key === first) : g.units.some((d) => d.key === first));
  return [...groups].sort((a, b) => Number(holds(b)) - Number(holds(a)));
}
